<template>
    <v-hover v-slot="{hover}">
        <div>
            <v-dialog v-model="del" persistent max-width="500">
                <v-card>
                    <v-card-title class="text-h5">
                    Biztosan törli a(z) {{product_name}}
                    </v-card-title>
                    <v-card-text>Amennyiben törli a termék véglegesen törlődik!<br>Az újbóli létrehozáshoz egy új termék felvétele szükséges!</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="del = false"
                    >
                        Mégsem
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="del = false"
                    >
                        Törlés
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-if="admin" v-model="modify" fullscreen>
                <CreateProduct @exit = "modify = false" :product_id="id"/>
            </v-dialog>
            <v-dialog v-model="detail" v-else>

            </v-dialog>

            <v-card v-if="id>=0" class="product_card" hover>
                <div v-if="title_length > 40" style="background-color:#920825; white-space: nowrap; overflow: hidden">
                    <v-card-title class="title white--text" style="" >{{product_name}}</v-card-title>
                </div>
                <div v-else style="background-color:#920825">
                    <v-card-title class="white--text">{{product_name}}</v-card-title>
                </div>
                <v-row>
                <v-col style="overflow: hidden; height:280px;">
                    <v-card-text>{{description}}</v-card-text>
                </v-col>
                <v-col cols="5">
                    <v-img width="140px" :src="index_picture"></v-img>
                </v-col>
                </v-row>
                <v-card-actions class="card_bottom" no-gutters>
                    <v-btn @click="detail = true" color="#920825" text>Tovább<v-icon>mdi-arrow-right-thin</v-icon></v-btn>
                </v-card-actions>
                <v-overlay v-if="admin" absolute :value="hover">
                    <v-row>
                        <v-btn id="btn_modify" class="mx-10" icon @click="modify = true"><v-icon size="80px">mdi-pencil</v-icon></v-btn>
                        <v-btn id="btn_delete" class="mx-10" icon @click="del = true"><v-icon size="80px">mdi-delete</v-icon></v-btn>
                    </v-row>
                </v-overlay>
            </v-card>

            <v-card v-else class="product_card" hover>
                <v-container fill-height>
                    <v-row  justify="center">
                        <v-btn id="btn_create" class="mx-10" icon @click="modify = true"><v-icon size="80px">mdi-plus-box</v-icon></v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </div>
    </v-hover>
</template>

<script>
import CreateProduct from '@/views/CreateProduct'
export default {
    data(){
        return{
            del: false,
            modify: false,
            detail:false,
            title_length: this.product_name.length
        }
    },
    name: "Product",
    components:{
        CreateProduct
    },
   
    props:{
        id:{
            type:Number
        },
        type_id:{
            type:Number
        },
        product_name:{
            type:String,
            default:""
        },
        description:{
            type:String
        },
        index_picture:{
            type:String
        },
        admin:{
            type:Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
    
    .product_card {
        width: 400px;
        min-height: 400px;
        margin: 20px 20px 20px 20px;
        display: flex;
        display: flex;
        flex-direction: column;
    }
    #btn_modify:hover{
        color: yellow;
    }
    #btn_delete:hover{
        color: red;
    }
     #btn_create:hover{
        color: green;
    }
    .card_bottom{
        margin-top: auto;
        border-style: solid none none none;
        border-color: #920825;
        border-width: 1px;
        

    }
    .title{
  /* animation properties */
  -moz-transform: translateX(0%);
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
  animation-delay: 10s;
  animation: my-animation 15s linear infinite;
}

@keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  to {
    -moz-transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
</style>